import { Spinner } from '@delmonicos/shared-design-system-react/src/components/spinner/spinner';
import { hasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { PropsWithChildren, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import {
  mustResetPassword,
  permissions,
  permissionsLoaded,
} from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';
import { Permission } from '@model/permission.model';

interface RoleGuardProps {
  permission?: Permission;
}

export function RoleGuard({
  children,
  permission,
}: Readonly<PropsWithChildren<RoleGuardProps>>): ReactNode {
  const userPermissions = useAppSelector(permissions);
  const needResetPassword = useAppSelector(mustResetPassword);
  const isLoaded = useAppSelector(permissionsLoaded);

  if (!isLoaded && !needResetPassword) {
    return <Spinner />;
  }

  if (
    !permission ||
    (userPermissions && hasAccessTo(userPermissions, permission))
  ) {
    return children;
  }

  return <Navigate to={APP_PATH.DASHBOARD} />;
}
